module.exports = __webpack_public_path__ + "media/images/web/og-38b447892b8f3519452fb47df767309a.jpg";